export default __webpack_public_path__ + "static/media/horse_shoe_tunnel.36c3eca4.png";